import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from 'src/app/modules/shared/state/signal-entity.store';
import {ClaimData} from 'src/app/modules/shared/models/claim.model';

export interface ClaimsDataState extends EntityState<ClaimData> {}

@Injectable({providedIn: 'root'})
export class ClaimsDataStore extends SignalEntityStore<ClaimData, ClaimsDataState>{
    constructor(){
        super({name: 'claims-data', idKey: 'index'});
    }
}
